import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { RangeShape } from '../shape';
import { baseAnnotationChannels, basePostInference, basePreInference } from './utils';
function extend(channel, extended, value, scale) {
  if (extended) return function () {
    return [0, 1];
  };
  var C = value[channel],
    C1 = value["".concat(channel, "1")];
  return function (i) {
    var _a;
    var offset = ((_a = scale.getBandWidth) === null || _a === void 0 ? void 0 : _a.call(scale, scale.invert(+C1[i]))) || 0;
    return [C[i], C1[i] + offset];
  };
}
export function AbstractRange() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$extendX = options.extendX,
    extendX = _options$extendX === void 0 ? false : _options$extendX,
    _options$extendY = options.extendY,
    extendY = _options$extendY === void 0 ? false : _options$extendY;
  return function (index, scale, value, coordinate) {
    var x = extend('x', extendX, value, scale.x);
    var y = extend('y', extendY, value, scale.y);
    var P = Array.from(index, function (i) {
      var _x = x(i),
        _x2 = _slicedToArray(_x, 2),
        x1 = _x2[0],
        x2 = _x2[1];
      var _y = y(i),
        _y2 = _slicedToArray(_y, 2),
        y1 = _y2[0],
        y2 = _y2[1];
      var p1 = [x1, y1];
      var p2 = [x2, y1];
      var p3 = [x2, y2];
      var p4 = [x1, y2];
      return [p1, p2, p3, p4].map(function (d) {
        return coordinate.map(d);
      });
    });
    return [index, P];
  };
}
var shape = {
  range: RangeShape
};
export var Range = function Range() {
  return AbstractRange();
};
Range.props = {
  defaultShape: 'range',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseAnnotationChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    required: true
  }, {
    name: 'y',
    required: true
  }]),
  preInference: _toConsumableArray(basePreInference()),
  postInference: _toConsumableArray(basePostInference())
};